// extracted by mini-css-extract-plugin
export default {"Link":"businessCard_Link__xK0Jq","isCompany":"businessCard_isCompany__WduQO"};